import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment as env } from '../../environments/environment';

export interface VacancyImpressionEvent {
  MarketVacancy_id: number;
  event_type: 'impression';
  rank: number;
  score: number | null;
  metadata?: {
    flag_state?: Record<string, boolean>;
    target_user_id?: number;
    [key: string]: unknown;
  };
}

@Injectable({ providedIn: 'root' })
export class MarketVacancyEventsService {
  private readonly MAX_BATCH = 50;

  constructor(private http: HttpClient) {}

  /**
   * Fire-and-forget batch POST of impression events. Silently swallows errors
   * so instrumentation never disrupts the UX.
   */
  public postImpressions(events: VacancyImpressionEvent[]): void {
    if (!events.length) return;
    const chunks: VacancyImpressionEvent[][] = [];
    for (let i = 0; i < events.length; i += this.MAX_BATCH) {
      chunks.push(events.slice(i, i + this.MAX_BATCH));
    }
    for (const chunk of chunks) {
      this.http
        .post(`${env.api}/market-vacancies/events/batch`, { events: chunk }, { withCredentials: true })
        .pipe(catchError(() => EMPTY))
        .subscribe();
    }
  }
}
